










import { defineComponent } from "@vue/composition-api";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";

export default defineComponent({
  name: "UnfollowConfirm",
  components: { BaseConfirm, BaseButton },
  model: {
    prop: "show",
  },
  props: {
    show: { required: true, type: Boolean, default: false },
  },
});
